import { useAudio } from '@utils/providers/audio-context.tsx';
import { motion } from 'framer-motion';
import { useCaption } from '@utils/providers/caption-context.tsx';

const CaptionMediaSlider = () => {
  const { currentTime, duration } = useAudio();
  const { setTimeAndSegment } = useCaption();

  return (
    <div className={'flex items-center h-full'}>
      <motion.input
        type="range"
        value={currentTime}
        className="w-full h-2 bg-gray-400 dark:bg-zinc-600 rounded-2xl appearance-none cursor-pointer"
        onChange={e => setTimeAndSegment(parseFloat(e.target.value))}
        aria-labelledby="continuous-slider"
        max={duration}
        min={0}
      />
    </div>
  );
};

export default CaptionMediaSlider;
